var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-content',{staticClass:"siteContent",attrs:{"padding":"0"}},[_c('v-container',{attrs:{"fluid":"","pa-0":""}},[_c('router-view')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }